import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { CourseListCard, SignUpForm } from "../../molecule";
import _ from "lodash";
import CourseTabContainer from "./CourseTabContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import { Actions } from "../../../core/modules/Actions";
import { DialogComponent, DurationButton, RadioButtonComponent } from "../../atom";
import moment from "moment";
import { APPROXIMATESIGN, DEFAULT_CURRENCY, onGetCurrencySymble } from "../../../core/Constant";


const TabItemTwo = ({ itemtwoData, onNavigatetoPreview, selectedPlan, handleRadioChange, isExpired, selectedCurrency = {} }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [courseID, setCourseId] = useState('');
  const [courseData, setCourseData] = useState({});
  const [itemData, setItemData] = useState([]);
  const [isRegistered, setIsRegistered] = useState(true);
  const [cList, setCList] = useState([]);
  const [signup, setSignUp] = useState(false);
  const [symbol, setSymbol] = useState();
  const [price, setPrice] = useState(0)
  const [duration, setDuration] = useState("")
  
  const currency = localStorage.getItem('GlobalCurrency')

  const isShowApproxiSign = selectedCurrency?.currency !== DEFAULT_CURRENCY
  

  const [isShow, setIsShow] = useState(0);
  const show = useSelector(state => state.common.get('show'));
  useEffect(() => {
    setIsShow(show == 1);
  }, [show]);

  const [selectedCourse, setSelectedCourse] = useState({})
  const [selectedCourseItem, setSelectedCourseItem] = useState({})

  const dispatch = useDispatch();

  const initCourse = useSelector((state) => state.guest.get('initCourse'));
  const topBannerCourses = useSelector((state) => state.guest.get('topBannerCourses'))

  useEffect(()=>{
     if (selectedCourse?.course_currencies) {
         if (selectedPlan) {
             const currencySymbol = onGetCurrencySymble(_.get(selectedPlan, "currency.currency"));
             const price =  _.get(selectedPlan, "price", "");
             setPrice(price)
             setSymbol(currencySymbol);
             if(selectedCourse?.duration !== null ){
                   setDuration(selectedCourse?.duration?.toString())
                } else {
                   setDuration(selectedPlan?.duration_weeks?.toString())
              }
         } else {
            const plan = selectedCourse?.course_currencies?.[0]
             const currencySymbol = onGetCurrencySymble(_.get(plan, "currency.currency"));
             const price = _.get(plan, "price", "");
             setPrice(price)
             setSymbol(currencySymbol);
             if(selectedCourse?.duration !== null ){
                   setDuration(selectedCourse?.duration?.toString())
                } else {
                   setDuration(plan?.duration_weeks?.toString())
            }
         }
     }
  },[currency, selectedPlan, selectedCourse])

  useEffect(() => {
    let list = [...topBannerCourses, ...initCourse];
    setCList(list);
    const id = location?.state?.course_id;
    const obj = _.find(list, item => item.id == id)
    setSelectedCourse(obj)
  }, [topBannerCourses, initCourse]);

  useEffect(() => {
    if(itemtwoData?.courses?.length > 0){
      const course = itemtwoData?.courses?.[0]
      setIsRegistered(course?.is_registered);
      setCourseData(course);
      setCourseId(course?.id)
    }
  }, [itemtwoData]);
  let list = [];

  useEffect(() => {
    const courseList = _.get(itemtwoData, "courses[0].course_contents", []);
    list = _.groupBy(courseList, "week");
    const array = _.values(courseList);
    setData(array);
    if(itemtwoData?.courses?.length > 0){
       const course = itemtwoData?.courses?.[0]
       setSelectedCourseItem(course)
    }
  }, [itemtwoData]);

  const onEnroll = () => {
    const isFree = courseData?.is_free;
    if (isFree || !isShow) {
      onRegister({ 
        course_id: courseID, 
        course_currency_id: selectedPlan?.id,
        is_free: isFree || !isShow 
      })
    } else {
      setSignUp(true)
    }
  };

  const onRegister = (params) => {
    dispatch(Actions.course.registerNewCourseByUser(params))
  }

  return (
    <Box>
      {isRegistered ? <Typography
        style={{ display: "flex", flexDirection: "column" }}
        color={"#2d3945"}
        fontSize={20}
        fontWeight={800}
      >
        Course Content
      </Typography> : null}

      { isRegistered ? <CourseListCard courseData={data} isRegistered={isRegistered} isExpired={isExpired} onEnroll={onEnroll} /> :  <CourseTabContainer courseData={data} onEnroll={onEnroll} /> }
      
      { (isExpired || !isRegistered ) && selectedCourse?.is_free === 0  && (
        <Grid container alignItems={"center"} justifyContent={"center"}>
          <Grid item>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mt: 5,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "28px",
                  color: "#2D3945",
                  mb: 2,
                }}
              >
                Select Plan
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  mb: 3,
                  width: "100%",
                }}
              >
                {selectedCourse?.course_currencies?.map((plan)=>{
                  return(
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                  {
                    (plan?.plan_name || (plan?.batch_month && plan?.batch_year)) && <RadioButtonComponent
                    checked={selectedPlan?.id?.toString() === plan?.id?.toString() }
                    value={plan?.id?.toString()}
                    handleChange={(event)=>{
                      handleRadioChange(event, selectedCourse?.course_currencies)
                    }}
                  />
                  }
                  
                  <Typography
                    sx={{
                      ml: 0.5,
                      fontSize: "18px",
                      fontWeight: 500,
                      color: "#2D3945",
                    }}
                  >
                    { `${plan?.plan_name || ""} `}
                  </Typography>
                   <span
                      style={{
                        fontFamily: "Montserrat",
                        fontWeight: 800,
                        fontSize: 15,
                        color: "#2d3945",
                      }}
                    >
                      { plan?.plan_name ? " -" : ""  }
                      {` ${plan?.batch_month ? moment()
                        .month(Number(plan?.batch_month) - 1)
                        .format("MMMM") : ""} ${plan?.batch_year ? plan?.batch_year : ""}`}
                    </span>
                </Box>
                  )
                })}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {isShow && (
                  <DurationButton
                    title="Price"
                    subtitle={
                      courseData?.is_free
                        ? "Free"
                        : `${ price && isShowApproxiSign ? APPROXIMATESIGN : "" }${symbol + price}`
                    }
                  />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
       )}
           
        {
         (isExpired || !isRegistered) && <Grid container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5%' }}>
         <Grid>
           <TextButtonComponet
             text={"Enroll now"}
             classStyle={"btn btn-enroll"}
             onButtonClick={onEnroll}
           />
         </Grid>
        </Grid>
        }
        
      <DialogComponent
        isShowCloseButton={false}
        border={30}
        open={signup}
        backgroundColor="#fff"
        onClose={() => setSignUp(false)}
      >
        <SignUpForm isRegistered={true} stepIndex={1} cardSelectedPlan={selectedPlan} item={selectedCourseItem} onClose={() => setSignUp(false)} selectedCurrencyOp={selectedCurrency} />
      </DialogComponent>
    </Box>
  );
};

export default TabItemTwo;
